import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import Typography from "@mui/material/Typography";
const useStyles = makeStyles(() => ({
  headerStyles: {
    marginBottom: 24
  },
  subHeaderStyles: {
    marginBottom: 40
  }
}));
const QuizIntroduction = ({
  content
}) => {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    color: "textPrimary",
    className: classes.headerStyles
  }, content.header), /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    color: "textPrimary",
    className: classes.subHeaderStyles
  }, content.subHeader));
};
QuizIntroduction.propTypes = {
  content: PropTypes.object.isRequired
};
export default QuizIntroduction;